import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  #mainContainer
  #expandable

  static targets = ['collapseButton', 'profileButton', 'profileMenu']

  connect() {
    this.#mainContainer = document.querySelector('.main-container')
    this.#expandable = false
  }

  showSidebar(_e) {
    if(this.#isMobileScreen()) return
    if(this.#expandable) return

    this.element.classList.add('active')
    this.#mainContainer.classList.add('active')
  }

  hideSidebar(_e) {
    if(this.#isMobileScreen()) return
    if(this.#expandable) return

    this.element.classList.remove('active')
    this.#mainContainer.classList.remove('active')
  }

  toggleExpandable(_e) {
    this.#expandable = !this.#expandable
  }

  toggleProfileMenu(_e) {
    this.profileMenu.classList.toggle('active')
  }

  #isMobileScreen() {
    return window.innerWidth < 767
  }

  get collapseButton() {
    return this.collapseButtonTarget
  }

  get profileButton() {
    return this.profileButtonTarget
  }

  get profileMenu() {
    return this.profileMenuTarget
  }
}
